import { useLang } from "../context/LanguageContext";
import { useForm } from "../context/FormContext";

export default function ProgressBar() {
  const { tArr } = useLang();
  const { currentStep, totalSteps } = useForm();

  const stepNames = tArr("progress.steps");
  const currentName = stepNames[currentStep - 1] ?? "";
  const progress = (currentStep / totalSteps) * 100;

  return (
    <div className="w-full bg-white border-b border-slate-100 px-4 py-3">
      <div className="max-w-[480px] mx-auto">
        <div className="flex items-center justify-between mb-2">
          <span className="text-xs font-semibold text-slate-500 uppercase tracking-wide">
            {currentName}
          </span>
        </div>
        <div className="w-full bg-slate-100 rounded-full h-1.5 overflow-hidden">
          <div
            className="h-full rounded-full transition-all duration-500 ease-out"
            style={{ width: `${progress}%`, background: '#059669' }}
          />
        </div>
        <div className="flex justify-between mt-2">
          {Array.from({ length: totalSteps }).map((_, i) => (
            <div
              key={i}
              className={`w-1.5 h-1.5 rounded-full transition-all duration-300 ${
                i + 1 < currentStep
                  ? ""
                  : i + 1 === currentStep
                  ? "scale-125"
                  : "bg-slate-200"
              }`}
              style={i + 1 <= currentStep ? { background: '#059669' } : undefined}
            />
          ))}
        </div>

      </div>
    </div>
  );
}
